/**
 * Хранилище полученных сообщений
 * Используем Set для отслеживания уже полученных ID
 */
const receivedMessages = new Map(); // id -> сообщение
let messagesList = []; // массив сообщений в порядке получения

/**
 * Добавляет новые сообщения (которых еще не было)
 * @param {Array} newMessages - Массив новых сообщений с сервера
 * @returns {Array} Массив только новых сообщений
 */
export function addNewMessages(newMessages) {
    const addedMessages = [];
    
    for (const message of newMessages) {
        // Если сообщения с таким ID еще нет
        if (!receivedMessages.has(message.id)) {
            receivedMessages.set(message.id, message);
            messagesList.unshift(message); // Добавляем в начало (новые сверху)
            addedMessages.push(message);
        }
    }
    
    return addedMessages;
}

/**
 * Возвращает все сообщения
 * @returns {Array} Массив всех сообщений
 */
export function getAllMessages() {
    return [...messagesList];
}

/**
 * Очищает все сообщения (для тестирования)
 */
export function clearMessages() {
    receivedMessages.clear();
    messagesList = [];
}